import { useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { getIonIcon } from "../commons/IonIconList";
import { Button, Dropdown } from "flowbite-react";
import { BiHeart, BiMenu } from "react-icons/bi";
import { IoAddCircleOutline, IoBasketOutline } from "react-icons/io5";
import { useShowCartButton } from "../hooks/appHook";

const links = [
    { path: '/events', label: 'Évènements', icon: 'calendar-outline' },
    { path: '/account/tickets/create', label: 'Créer un évènement', icon: 'add-outline' },
];

const EventsLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showCartButton, setShowCartButton] = useShowCartButton();

    useEffect(() => {
        setShowCartButton(false);
        return () => setShowCartButton(false);
    }, []);

    return (
        <>
        <div className={`h-screen w-full overflow-auto flex flex-col pt-[69px]`}>
            <header className={`bg-gray-900 fixed w-full top-0 left-0 z-10`}>
                <div className={`max-w-screen-2xl mx-auto px-10 py-[17px] flex items-center`}>
                    {/* brand */}
                    <div className={`shrink-0`}>
                        <img src="/assets/images/logo-nobg.png" className={`w-24 rounded-md`} alt=""/>
                    </div>

                    {/* menu */}
                    <ul className={`m-0 p-0 ml-16 gap-7 hidden lg:flex`}>
                        {links
                            // .filter(x => !x.scope || x.scope === app)
                            .map((item, idx) => {
                                const Icon = getIonIcon(item.icon);
                                return (
                                    <li key={idx + 1}>
                                        <Link
                                            to={item.path}
                                            className={`
                                                text-white text-[14.7px] font-medium flex items-center
                                                ${location.pathname === item.path || (item.path !== '/account' && location.pathname.startsWith(item.path + '')) ? '!text-orange-500 border-l-2 border-orange-500 pl-2' : ''}
                                            `}
                                        >
                                            {Icon ? <Icon size={item.iconSize || 17} className={`mr-2`} /> : null}
                                            {item.label}
                                        </Link>
                                    </li>
                                )
                            })
                        }
                    </ul>

                    {/* aside */}
                    <div className={`ml-auto flex items-center shrink-0`}>
                        {showCartButton ? (
                            <Button className={`bg-transparent hover:!bg-transparent text-white`}>
                                <IoBasketOutline size={20} className={`mr-1.5`} />
                            </Button>
                        ) : null}
                        <Button onClick={() => navigate('/account/tickets/create')} className={`bg-orange-500 hover:!bg-orange-600 text-white`}>
                            <IoAddCircleOutline size={16} className={`mr-1.5`} /> Créer
                        </Button>
                        <div className={`block lg:hidden ml-4`}>
                            <Dropdown
                                inline
                                className={`w-[200px]`}
                                renderTrigger={() => <BiMenu size={25} color="#fff" />}
                                label=""
                            >
                                {links.map((item, idx) => (
                                    <Dropdown.Item key={idx + 1} className={`hover:text-orange-500`}>
                                        <Link to={item.path}>{item.label}</Link>
                                    </Dropdown.Item>
                                ))}
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </header>
            <div className={`w-full`}>
                <Outlet />
            </div>
            <footer className={`w-full mt-auto bg-gray-100 py-3`}>
                <div className={`max-w-screen-2xl px-5 mx-auto`}>
                    <p className={`text-xs text-center text-gray-400 font-semibold`}>
                        With <BiHeart className={`text-orange-500 inline-block`} />
                        &nbsp;by Sarrux
                    </p>
                </div>
            </footer>
        </div>
        </>
    );
};

export default EventsLayout;